import { HolidayYearActionKind } from './actions';
export const holidayYearReducer = (state, { type, payload }) => {
    switch (type) {
        case HolidayYearActionKind.ModifyEndDate: {
            return { ...state, end: payload };
        }
        case HolidayYearActionKind.ModifyWorkingDays: {
            return { ...state, workingDays: payload };
        }
        default:
            return state;
    }
};
